const WebFont = require("webfontloader");
const fontLoadedMessage = "velaro-webfont-loaded";

const webSafe = ["arial"];

async function preloadFont(context: any, font: string) {
  var promise = new Promise(function(resolve) {
    if (webSafe.indexOf(font) > -1) {
      resolve();
      return;
    }

    // hack to get around: https://github.com/typekit/webfontloader/issues/369
    var onMessage = (ev: MessageEvent) => {
      if (ev.data === fontLoadedMessage) {
        window.removeEventListener("message", onMessage);
        resolve();
      }
    };

    window.addEventListener("message", onMessage, false);

    let config = {
      google: {
        families: [getFontFamily(font)]
      },
      context: context,
      active: function() {
        window.postMessage(fontLoadedMessage, "*");
      }
    };

    WebFont.load(config);
  });

  return promise;
}

function getFontFamily(font: string) {
  switch (font) {
    case "open_sans":
      return "Open Sans";
    case "roboto":
      return "Roboto";
    case "source_sans_pro":
      return "Source Sans Pro";
    default:
      return "Open Sans";
  }
}

export default preloadFont;
